var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.slug)?_c('span',{class:{
    badge: true,
    [`badge-request-credit-status-${_vm.slug}`]: true,
}},[_vm._v(_vm._s(_vm.status_text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }